import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('nxs_cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('nxs_cookie_consent', '1');
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem('nxs_cookie_consent', '0');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Consentement cookies">
      <div className="cookie-banner__inner">
        <p className="cookie-banner__text">
          Ce site utilise des cookies pour analyser nos visites et ameliorer votre experience.
          Aucune donnee n'est partagee avec des tiers.{' '}
          <Link to="/mentions-legales" className="cookie-banner__link">En savoir plus</Link>
        </p>
        <div className="cookie-banner__actions">
          <button className="cookie-banner__accept" onClick={accept}>Accepter</button>
          <button className="cookie-banner__refuse" onClick={refuse}>Refuser</button>
        </div>
      </div>
    </div>
  );
}
